var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-header'),_vm._v(" "),(_vm.type === 'proceduring')?_c('applications-proceduring',{ref:"applicationsProceduring"}):_vm._e(),_vm._v(" "),(_vm.type === 'competition')?_c('applications-competition',{ref:"applicationsCompetition"}):_vm._e(),_vm._v(" "),_c('my-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-757f2d34","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/applications.vue
// module id = null
// module chunks = 